import { useProdutos } from '../../hooks/useProdutos';
import Select from "react-select"

export const SelectProduto = ({ onChange } : any) => {
    const {produtos} = useProdutos();

    const produtoOptions = produtos.map((produto) => ({
        key: produto.CodProduto,
        value: produto.CodProduto,
        label: produto.NomeProduto
    }));

    const handleProdutoUpdate = (event: any) => {
        if(event !== null ){
            onChange(event);
        } else {
            onChange(null);
        }
    };

    return (
        <Select
        isClearable
        placeholder="Selecione um Produto"
        options={produtoOptions}
        onChange={handleProdutoUpdate}
        />
    )
};
